export default {
    computed: {
        isImpersonating() {
            return this.nal.user?.isImpersonating;
        },
        isNovaImpersonating() {
            return this.nal.user?.isNovaImpersonating;
        },
    },
};